export default __webpack_public_path__ + "static/media/back-arrow-white.17b24179.svg";